import * as types from './types';

const initialState = {
  getYusaOvernightCampStaff: {},
  postYusaOvernightCampStaff: {},
  getYusaOvernightCampWages: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case 'RESET_KEY':
      return {
        ...state,
        [action.payload.key]: {}
      };

    case types.YUSA_OVERNIGHT_CAMP_GET_TOTAL_STAFF_SUCCESS: {
      return {
        ...state,
        getYusaOvernightCampStaff: action.payload
      };
    }
    case types.YUSA_OVERNIGHT_CAMP_GET_TOTAL_STAFF_FAILURE:
      return { ...state, error: action.payload };

    case types.YUSA_OVERNIGHT_CAMP_POST_TOTAL_STAFF_SUCCESS: {
      return {
        ...state,
        postYusaOvernightCampStaff: action.payload
      };
    }
    case types.YUSA_OVERNIGHT_CAMP_POST_TOTAL_STAFF_FAILURE:
      return { ...state, error: action.payload };

    case types.YUSA_OVERNIGHT_CAMP_WAGES_SUCCESS: {
      return {
        ...state,
        getYusaOvernightCampWages: action.payload
      };
    }
    case types.YUSA_OVERNIGHT_CAMP_WAGES_FAILURE:
      return { ...state, error: action.payload };
    default:
      return state;
  }
}
